import Vue from 'vue'
import vuex from 'vuex'
Vue.use(vuex);
export default new vuex.Store({//store对象
    state:{
    	UserId:"",
    	nowAddress:"",
    	AdminInfo:"",
      	tabChoosed:"home",
      	tabBarShow:true
    },
    mutations:{
        changeTabChoosed(state,v){
        	state.tabChoosed = v;
        },
        changeTabBarShow(state,v){
        	state.tabBarShow = v;
        },
        getAdminInfo(state,v){
        	state.AdminInfo = v;
        },
        getUserId(state,v){
        	state.UserId = v;
        },
        setNowAdd(state,v){
        	state.nowAddress = v;
        },
    }
})


// WEBPACK FOOTER //
// ./src/store/index.js